import { defineStyle, defineStyleConfig, ComponentStyleConfig } from '@chakra-ui/react';

const allcaps = defineStyle({
  textTransform: 'uppercase',
  fontWeight: '500',
  letterSpacing: 'wider',
});

export const textTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle: {
    mb: 4,
  },
  variants: {
    allcaps,
  },
});
